<template>
  <div>
    <b-modal size="lg" hide-footer :id="modalId" title="Restore Version">

      <div v-if="isLoading" class="text-center">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>

      <div v-if="!isLoading && versions.length === 0" class="alert alert-danger">
        No previous versions to show
      </div>

      <div v-if="!isLoading && versions.length" class="table-responsive mb-0">
        <table class="table mb-0 table-centered">
          <thead class="thead-light">
          <tr>
            <th>Changed At</th>
            <th>Difference</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="version in versions" v-if="version.diff['body']">
            <td>{{ displayTimeAgo(version.created_at) }}</td>
            <td>
              <div class="note-versions-body-diff" v-html="version.diff['body']"></div>
            </td>
            <td style="text-align: right;">
              <button
                  type="button"
                  class="btn btn-itg btn-sm"
                  @click="restoreVersion(version)"
              >
                Restore
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import Dates from "../../../../../../mixins/Dates";
import {mapActions} from "vuex";

export default {
  name: "TicketNoteVersionsModal",
  props: ['note', 'modalId'],
  mixins: [Dates],
  data() {
    return {
      isLoading: false,
      isRestoring: false,
      versions: []
    }
  },
  created() {
    this.fetch();
  },
  computed: {
   // versionsWithoutCurrent() {
   //   let last = _.last(this.versions);
   //   return _.without(this.versions, last);
   // }
  },
  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    fetch() {
      let vm = this;
      vm.isLoading = true;
      axios.get(API_BASE + '/tickets/' + this.note.ticket_id + '/notes/' + this.note.id + '/versions').then(r => {
        vm.isLoading = false;
        vm.versions = _.reverse(r.data);
      }).catch(e => {
        vm.isLoading = false;
        vm.versions = [];
        vm.$notify.error({
          title: 'Error',
          message: 'Error loading versions'
        });
      });
    },

    getModelData(version) {
      return JSON.parse(version.model_data);
    },

    restoreVersion(version) {
      let vm = this;
      vm.isRestoring = true;
      axios.post(API_BASE + '/tickets/' + this.note.ticket_id + '/notes/' + this.note.id + '/versions/' + version.version_id + '/restore').then(r => {
        vm.isRestoring = false;
        vm.$bvModal.hide(this.modalId);
        vm.reloadTicket();
      }).catch(e => {
        vm.isRestoring = false;
        vm.$notify.error({
          title: 'Error',
          message: 'Error restoring version'
        });
      });
    }
  }
}
</script>

<style>
.note-versions-body-diff p:last-child {
  margin-bottom: 0 !important;
}
</style>